import axios from 'axios';
import { observable, action, computed, runInAction } from 'mobx';

// import jwt from 'jsonwebtoken';

import Storage from '../services/Storage';

class Auth { // extends singleton {
    @observable user = null;
    @observable token = null;
    @observable isLoggingIn = false;

    @computed
    get isLoggedIn() {
        // TODO Add Token expiration
        return !!this.user;
    }

    constructor() {
        // this.isLoggingIn = true;
        // TODO put to config URL
        // axDefault.baseURL = 'http://localhost:8080';
        this.apiClient = axios.create({});
        this.dmTokenName = 'token';
        this.dmTokenNameCheck = 'dm_token_is_set';
        this.dmLogoutRedirect = 'dm_logout_redirect';

        this.token = Storage.get(this.dmTokenName);

        if (this.token) {
            // axDefault.headers.common.Authorization = `Bearer ${this.token}`;
            this.apiClient.defaults.headers.Authorization = `Bearer ${this.token}`;

            console.log('[AUTH] User nulled prior token population');
            this.user = null; // TODO jwt.verify(token, JWT_SECRET);
            // TODO Check for validity of Token etc.
            this.populateUser();
        }

        // Check Token in Cookies
        // If the cookie was set by the api then we have dm_token_is_set=1 and token will be sent by browser through headers
        const dmCookie = Storage.getCookie(this.dmTokenNameCheck);
        if (dmCookie === '1') {
            // Assume authenticated through cookie
            console.log('[AUTH] User nulled no token');
            this.user = null; // TODO jwt.verify(token, JWT_SECRET);
            // TODO Check for validity of Token etc.
            this.populateUser();
        }
    }

    @action.bound
    onLoginSubmit = async (form) => {
        // console.log('Login Form Values!', form.values());
        try {
            runInAction(async () => {
                this.isLoggingIn = true;
                const res = await this.apiClient.post('/auth/local', form.values());

                this.token = res.data.token;
                // TODO simplify token setup
                // axDefault.headers.common.Authorization = `Bearer ${this.token}`;
                this.apiClient.defaults.headers.Authorization = `Bearer ${this.token}`;
                Storage.set('token', this.token);

                // Clear form from values
                form.clear();

                // Populate user data
                this.populateUser();
            });
        } catch (err) {
            runInAction(async () => {
                form.invalidate('Login failed. Please check your credentials.');
                this.isLoggingIn = false;
            });
        }
    }

    @action.bound
    onSignupSubmit = async (form) => {
        // console.log('Signup Form Values!', form.values());
        try {
            runInAction(async () => {
                this.isLoggingIn = true;
                const res = await this.apiClient.post('/api/users/signup', form.values());

                this.token = res.data.token;
                // TODO simplify token setup
                // axDefault.headers.common.Authorization = `Bearer ${this.token}`;
                this.apiClient.defaults.headers.Authorization = `Bearer ${this.token}`;
                Storage.set('token', this.token);

                // Clear form from values
                form.clear();

                // Populate user data
                this.populateUser();
            });
        } catch (err) {
            if (err.response && err.response.data && err.response.data.errors) {
                Object.keys(err.response.data.errors).map((fieldName) => {
                    const error = err.response.data.errors[fieldName];
                    return form.$(fieldName).invalidate(error.message);
                });
            }
            // TODO Sentry the error
            runInAction(async () => {
                form.invalidate('Signup failed. Check the form fields.');
                this.isLoggingIn = false;
            });
        }
        return null;
    }

    @action
    onErrorSubmit(form) {
        runInAction(async () => {
            // console.log('ERROR Values!', form.errors());
            form.invalidate('Please fix the errors on the form before submitting again!');
            this.isLoggingIn = false;
        });
    }

    populateUser = async () => {
        try {
            this.isLoggingIn = true;
            const res = await this.apiClient.get('/api/users/me');

            console.log('[AUTH] User data set to', res.data);
            this.user = res.data;
            this.isLoggingIn = false;
            Storage.set('user', JSON.stringify(this.user));
        } catch (err) {
            console.error('AUTH ERROR', err);
            this.logout();
        }
        return null;
    }

    @action
    logout() {
        runInAction(async () => {
            // Reset locals
            console.log('[AUTH] User nulled in logout routine');
            this.token = null;
            this.user = null;
            // Remove Storage
            Storage.remove('token');
            Storage.remove('user');

            // Force local deletion
            Storage.removeCookie('token');
            Storage.removeCookie(this.dmTokenNameCheck);


            // Logout Mechanism for API Set
            const logoutRedirect = Storage.getCookie(this.dmLogoutRedirect);
            if (logoutRedirect && logoutRedirect.length > 0) {
                // Force window location change
                window.location = decodeURIComponent(logoutRedirect);
            }
        });
    }

    /**
     * API Get Method
     * @param url
     * @param params
     */
    apiGet = async (url, params) => {
        const res = await this.apiClient.get(url, { params });
        return res.data;
    }
    // TODO Handle errors and return

    /**
     * API Get Method with Total Count
     * @param url
     * @param params
     */
    apiGetWithTotalCount = async (url, params) => {
        const res = await this.apiClient.get(url, { params });
        const total = res.headers && res.headers['x-total-count'] ? res.headers['x-total-count'] : 0;
        return { data: res.data, total };
    }
    // TODO Handle errors and return

    /**
     * API Delete Method
     * @param url
     * @param data
     */
    apiCreate = async (url, data) => {
        const res = await this.apiClient.post(url, data);
        return res.data;
    }
    // TODO Handle errors and return

    /**
     * API Delete Method
     * @param url
     * @param data
     */
    apiUpdate = async (url, data) => {
        const res = await this.apiClient.put(url, data);
        return res.data;
    }
    // TODO Handle errors and return

    /**
     * API Delete Method
     * @param url
     * @param params
     */
    apiDelete = async (url, params) => {
        const res = this.apiClient.del(url, { params });
        return res.data;
    }
    // TODO Handle errors and return
}

// Export as new so it's a singleton
const singleton = new Auth();
export default singleton;

